import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { FAILURE_NO_PAYOUT_RATIONALES, REQUEST_NO_PAYOUT_RATIONALES, SUCCESS_NO_PAYOUT_RATIONALES } from './actions';

export function noPayoutRationalesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_NO_PAYOUT_RATIONALES:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
